<template>
    <div class="ls-copy-content--container">
        <span>{{ text }}</span>
        <LsButton
            text="Copy"
            test-id="copy"
            track-id="ls_copy_content-copy"
            :min-width="false"
            @click="onCopy"
        />
    </div>
</template>

<script>
import VueTypes from 'vue-types';
import { lsToastService } from 'ls-vue-common';
import { LsButton } from '@/components/common';

export default {
    name: 'LsCopyContent',
    components: { LsButton },
    props: {
        text: VueTypes.string.isRequired,
    },

    methods: {
        onCopy() {
            this.$copyText(this.text).then(this.onCopySuccess, this.onCopyFailure);
        },
        onCopySuccess() {
            lsToastService.open({
                message: 'Message copied to clipboard',
                type: 'is-primary',
            });
        },
        onCopyFailure() {
            lsToastService.open({ message: 'Unable to copy message', type: 'is-error' });
        },
    },
};
</script>
<style lang="scss" scoped>
.ls-copy-content--container {
    background-color: $secondary-light;
    padding: 15px;
    color: $secondary-dark;

    button {
        margin-top: 12px;
    }
}
</style>
